import SbForm from './src/form.vue'

export * from './types'

export default SbForm
